import React, { useCallback, useEffect, useState } from "react";
import { api, rp } from "@/lib/api";

export default function SourceReport() {
  const [range, setRange] = useState({ from: "", to: "" });
  const [data, setData] = useState(null);
  const [modes, setModes] = useState(null);

  const load = useCallback(async () => {
    const r = await api.get("/reports/sources", {
      params: { date_from: range.from || undefined, date_to: range.to || undefined },
    });
    setData(r.data);
    const m = await api.get("/reports/service-modes", {
      params: { date_from: range.from || undefined, date_to: range.to || undefined },
    });
    setModes(m.data);
  }, [range]);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-source-report">
      <h1 className="font-display text-3xl tracking-tight">Sumber Booking</h1>
      <p className="mt-1 text-sm text-ink-soft">Lihat channel mana yang paling banyak membawa penyewa.</p>

      <div className="mt-4 flex flex-wrap items-end gap-2">
        <label className="text-xs text-ink-soft">Dari
          <input data-testid="src-from" type="date" value={range.from} onChange={(e) => setRange({ ...range, from: e.target.value })}
            className="ml-2 h-10 rounded-md border border-input bg-white px-3 text-sm" /></label>
        <label className="text-xs text-ink-soft">Sampai
          <input data-testid="src-to" type="date" value={range.to} onChange={(e) => setRange({ ...range, to: e.target.value })}
            className="ml-2 h-10 rounded-md border border-input bg-white px-3 text-sm" /></label>
        <button data-testid="src-clear" onClick={() => setRange({ from: "", to: "" })}
          className="h-10 px-4 rounded-md border border-black/15 text-sm">Semua waktu</button>
      </div>

      {data && (
        <>
          <div className="mt-5 grid grid-cols-2 md:grid-cols-3 gap-3">
            <Stat label="Total Booking" value={data.total_bookings} testid="src-total-bookings" />
            <Stat label="Total Pendapatan" value={rp(data.total_revenue)} testid="src-total-revenue" />
            <Stat label="Channel Teratas" value={data.rows[0]?.source || "—"} testid="src-top-channel" />
          </div>

          <div className="mt-5 overflow-x-auto bg-white border border-black/10 rounded-lg">
            <table className="w-full text-sm">
              <thead className="bg-cream-dark text-left text-[11px] uppercase tracking-widest text-ink-soft">
                <tr><th className="p-3">Sumber</th><th className="p-3">Booking</th><th className="p-3">Porsi</th>
                  <th className="p-3">Customer Baru</th><th className="p-3">Pendapatan</th></tr>
              </thead>
              <tbody className="divide-y divide-black/5">
                {data.rows.map((r) => (
                  <tr key={r.source} data-testid={`src-row-${r.source}`}>
                    <td className="p-3 font-medium">{r.source}</td>
                    <td className="p-3">{r.bookings}</td>
                    <td className="p-3">
                      <div className="flex items-center gap-2">
                        <div className="h-2 w-24 rounded-full bg-black/5 overflow-hidden">
                          <div className="h-full bg-lm-red" style={{ width: `${r.share_percent}%` }} />
                        </div>
                        <span className="text-xs text-ink-soft">{r.share_percent}%</span>
                      </div>
                    </td>
                    <td className="p-3">{r.new_customers}</td>
                    <td className="p-3 whitespace-nowrap">{rp(r.revenue)}</td>
                  </tr>
                ))}
                {data.rows.length === 0 && <tr><td colSpan={5} className="p-5 text-ink-soft">Belum ada data.</td></tr>}
              </tbody>
            </table>
          </div>
        </>
      )}

      {modes && (
        <div className="mt-8" data-testid="service-mode-report">
          <h2 className="text-base font-semibold">Jenis Layanan</h2>
          <p className="mt-1 text-xs text-ink-soft">
            Hanya tiga jenis layanan: Pickup, Delivery (kurir diatur customer), dan Main di Venue.
            Main di Venue dipecah per sumber booking — bukan jenis layanan yang berbeda.
          </p>
          <div className="mt-3 overflow-x-auto bg-white border border-black/10 rounded-lg">
            <table className="w-full text-sm">
              <thead className="bg-cream-dark text-left text-[11px] uppercase tracking-widest text-ink-soft">
                <tr><th className="p-3">Layanan</th><th className="p-3">Booking</th><th className="p-3">Porsi</th><th className="p-3">Pendapatan</th></tr>
              </thead>
              <tbody className="divide-y divide-black/5">
                {modes.rows.map((r) => (
                  <tr key={r.service_mode} data-testid={`mode-row-${r.service_mode}`}>
                    <td className="p-3 font-medium">{r.label}</td>
                    <td className="p-3">{r.bookings}</td>
                    <td className="p-3 text-xs text-ink-soft">{r.share_percent}%</td>
                    <td className="p-3 whitespace-nowrap">{rp(r.revenue)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-3 grid sm:grid-cols-2 gap-3">
            <Stat label="Main di Venue — Online" value={modes.venue_split.online.bookings} testid="venue-online-count" />
            <Stat label="Main di Venue — Dibantu Partner" value={modes.venue_split.partner_assisted.bookings} testid="venue-partner-count" />
          </div>
        </div>
      )}
    </div>
  );
}

const Stat = ({ label, value, testid }) => (
  <div className="bg-white border border-black/10 rounded-lg p-4" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-widest text-ink-soft">{label}</div>
    <div className="mt-1.5 text-2xl font-semibold">{value}</div>
  </div>
);
